

export default {
    data() {
        return {
            isFilterChange: false,

        }
    },
    computed: {

    },
    watch: {

    },
    methods: {
        /**
     * @description 開啟助理/空間下拉
     */
        async openAssistSelect(index, type) {
            try {
                this.petServiceGroupList.forEach(item => {
                    item.editSpaceEnabled = false
                }) // 先關閉所有select
                this.petServiceGroupList.forEach(item => {
                    item.editAssistantEnabled = false
                }) // 先關閉所有select
                if (type === 'prices') {
                    this.$set(this.petServiceGroupList[index], 'editAssistantEnabled', true) // 再打開這個select
                }
                if (type === 'space') {
                    this.$set(this.petServiceGroupList[index], 'editSpaceEnabled', true) // 再打開這個select
                }
            } catch (error) {
                console.error(error.message)
            }
        },
        /**
         * @description 找出助理下拉選單內容
         * @param {*} defaultValue 
         * @param {*} isSpace 
         */
        async mixinTryToFetchHelperList(defaultValue, isSpace) {
            try {
                this.tryingAssignList = true
                const { items } = await this.$store.dispatch('order/fetchServiceHelperList', {
                    orderId: defaultValue.id,
                    scheduleItemTypes: isSpace ? ['space'] : ['cosmetic']
                })
                const excludeCurrentBeautician = () => {
                    this.assignList = items.filter(({ id }) => (id !== defaultValue.scheduleItem.id))
                }
                excludeCurrentBeautician()
                this.tryingAssignList = false
            } catch (error) {
                console.error(error.message)
            }
        },
        /**
         * @description remove-add 的儲存API
         * @param {*} defaultData 使用者打開視窗時的資料
         * @param {*} itemId 新/舊 助理id
         */
        async storeAssignHelperApiForRemoveAdd(defaultData, itemId) {
            await this.$store.dispatch('order/storeAssignHelper', {
                id: defaultData.id, // orderId -> 訂單id
                itemId: itemId['ori'],
                action: 'remove'
            })
            await this.$store.dispatch('order/storeAssignHelper', {
                id: defaultData.id, // orderId -> 訂單id
                itemId: itemId['new'],
                action: 'add'
            })
        },
        /**
     * @description 決定打API時是要哪種action
     */
        decideActionStatus(isSpace, defaultData, submitData) {
            try {
                // 是開啟助理下拉 && 本來有助理 && 現在選到的助理變為不指定
                if (isSpace === 0 && defaultData.helpers[0].id.length > 0 && submitData.helpers[0].id.length === 0) {
                    return {
                        action: 'remove',
                        itemId: defaultData.helpers[0].id
                    }
                }
                // 是開啟空間下拉 && 本來有空間 && 現在變沒有空間 
                if (isSpace === 1 && defaultData.spaceHelpers[0].id.length > 0 && submitData.spaceHelpers[0].id.length === 0) {
                    return {
                        action: 'remove',
                        itemId: defaultData.spaceHelpers[0].id
                    }
                }
                // 是開啟空間下拉 && 本來有空間 && 現在空間可能轉到別的空間去
                if (isSpace === 1 && defaultData.spaceHelpers[0].id.length > 0 && submitData.spaceHelpers[0].id.length > 0) {
                    return {
                        action: 'remove-add',
                        itemId: {
                            ori: defaultData.spaceHelpers[0].id,
                            new: submitData.spaceHelpers[0].id
                        }
                    }
                }
                // 是開啟助理下拉 && 本來有助理 && 現在助理可能轉到別的助理去
                if (isSpace === 0 && defaultData.helpers[0].id.length > 0 && submitData.helpers[0].id.length > 0) {
                    return {
                        action: 'remove-add',
                        itemId: {
                            ori: defaultData.helpers[0].id,
                            new: submitData.helpers[0].id
                        }
                    }
                }
                return {
                    action: 'add',
                    itemId: ''
                }
            } catch (error) {
                console.error(error.message)
            }
        },
        /**
     * @description 關閉助理選擇下拉選單
     */
        cancelAssignEdit(index, type) {
            if (type === 'prices') {
                this.$set(this.petServiceGroupList[index], 'editAssistantEnabled', false)
            } else {
                this.$set(this.petServiceGroupList[index], 'editSpaceEnabled', false)
            }
            this.openCloseAssistType(type, false)
        },
        /**
         * @description 儲存使用者選的助理
         * @param {*} action 此次是remove / add / remove-add
         * @param {*} saveId 儲存的助理id
         * @param {*} isSpace 是否為空間
         * @param {*} defaultData 預設值
         * @param {*} submitData 使用者修改值
         */
        async mixinStoreAssignHelperApi(action, saveId, isSpace, defaultData, submitData) {
            try {
                let itemId = ''
                if (action === 'remove' && saveId.length > 0) {
                    itemId = saveId
                }
                if (action === 'add' && saveId.length === 0 && isSpace === 0) {
                    itemId = submitData.helpers[0].id // 助理的 id編號
                }
                if (action === 'add' && saveId.length === 0 && isSpace === 1) {
                    itemId = submitData.spaceHelpers[0].id // 助理的 id編號
                }
                await this.$store.dispatch('order/storeAssignHelper', {
                    id: defaultData.id, // orderId -> 訂單id
                    itemId,
                    action
                })
            } catch (error) {
                console.error(error.message)
            }
        },
        /**
     * @description 助理顯示詞
     */
        helperWords(item, key) {
            let showText = ''
            if (item.orderDetail[key].length > 0) {
                showText = item.orderDetail[key].map(item => item.name).join('')
            }
            return showText.length > 0 ? showText : '不指派'
        },
        /**
     * @description 依照開啟助理的形式建立tag
     */
        openCloseAssistType(type, booleanStatus) {
            if (type === 'prices') {
                this.openAssignEditStatus = booleanStatus
            }
            if (type === 'space') {
                this.openSpaceEditStatus = booleanStatus
            }
        },
        /**
         * @description 當純顯示助理時，做這個function
         */
        helperShow(item) {
            const names = item.map(obj => obj.name);
            return names.join('、').length > 0 ? names.join('、') : '請選擇';
        },
        /**
         * @description 初始化helpers
         */
        initHelpers(drawerOrderData) {
            if (!drawerOrderData.helpers || drawerOrderData.helpers.length === 0) {
                drawerOrderData.helpers = [{
                    id: '',
                    name: '',
                }]
            }
            return drawerOrderData
        },
        /**
         * @description 初始化spaceHelpers
         */
        initSpaceHelpers(drawerOrderData) {
            if (!drawerOrderData.spaceHelpers || drawerOrderData.spaceHelpers.length === 0) {
                drawerOrderData.spaceHelpers = [{
                    id: '',
                    name: '',
                }]
            }
            return drawerOrderData
        },
    },
}
